'use strict';

angular.module('shiftTraderApp')
  .directive('saShiftForTrade', function () {
    return {
      templateUrl: 'views/directives/saShiftForTrade.html',
      restrict: 'EA',
      scope: {
        'me':'=',
        'workPeriod':'=',
        'initWorkPeriod':'='
      },
      controller: ['$scope', function($scope) {
        $scope.user = $scope.workPeriod.user;

        $scope.analysis = {
          initiator: {
            overlap: $scope.workPeriod._initiatorWorkPeriodOverlaps,
            daysOff: _.where($scope.workPeriod._initiatorAvailabilityResults.data, function(ar) {
              return ar.type === 'single' && (ar.avail === 'false' || ar.avail === false);
            }),
            weeklyUnavailable: _.where($scope.workPeriod._initiatorAvailabilityResults.data, function(ar) {
              return ar.type === 'weekly' && (ar.avail === 'false' || ar.avail === false);
            })
          },
          receiver: {
            overlap: $scope.workPeriod._receiverWorkPeriodOverlaps,
            daysOff: _.where($scope.workPeriod._receiverAvailabilityResults.data, function(ar) {
              return ar.type === 'single' && (ar.avail === 'false' || ar.avail === false);
            }),
            weeklyUnavailable: _.where($scope.workPeriod._receiverAvailabilityResults.data, function(ar) {
              return ar.type === 'weekly' && (ar.avail === 'false' || ar.avail === false);
            })
          }
        };

        $scope.analysis.initiator._totalOverlapInMinutes = _.reduce(_.pluck($scope.analysis.initiator.overlap, 'intInMin'), function(sum, num) {
          return sum + num;
        });

        $scope.analysis.receiver._totalOverlapInMinutes = _.reduce(_.pluck($scope.analysis.receiver.overlap, 'intInMin'), function(sum, num) {
          return sum + num;
        });

        $scope.toggleDetails = function() {
          $scope.showDetails = !$scope.showDetails;
        };

      }]
    };
  });
